import { apiClient } from "@/services/api";

/** 后端下发的运行时配置（`GET /api/v1/config`）。`null` = 未配置，入口应隐藏。 */
export interface RuntimeConfig {
  supabaseStudioUrl: string | null;
  baserowUrl: string | null;
  strapiUrl: string | null;
}

export const EMPTY_RUNTIME_CONFIG: RuntimeConfig = {
  supabaseStudioUrl: null,
  baserowUrl: null,
  strapiUrl: null,
};

/**
 * 只接受 http(s) 绝对地址：同一个静态产物要发到多环境，地址来自部署侧配置，
 * 写错（相对路径、`javascript:` 等）时按「未配置」处理，宁可不显示也不拼进 iframe。
 */
export function sanitizeExternalUrl(value: unknown): string | null {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  if (!/^https?:\/\//i.test(trimmed)) return null;
  return trimmed.replace(/\/+$/, "");
}

export async function getRuntimeConfig(): Promise<RuntimeConfig> {
  try {
    const response = await apiClient.get<Record<string, unknown>>("/config");
    const data = response.data ?? {};
    return {
      supabaseStudioUrl: sanitizeExternalUrl(data.supabase_studio_url),
      baserowUrl: sanitizeExternalUrl(data.baserow_url),
      strapiUrl: sanitizeExternalUrl(data.strapi_url),
    };
  } catch {
    // 配置端点不可用（后端版本落后 / 网络异常）时按「全部未配置」降级，页面照常渲染。
    return EMPTY_RUNTIME_CONFIG;
  }
}
